"use strict";
// --------------------------------------------------
// IF EXISTS HELPER
// Return value or default
// --------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifexists = void 0;
function ifexists(data, options) {
    if (data !== null && data !== undefined) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return options.fn(this);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return options.inverse(this);
}
exports.ifexists = ifexists;
